const link =  "https://remember-1u57.onrender.com"
//https://remember-1.onrender.com
//http://localhost:5000
module.exports = link
           
